import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=7b9f7279&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=js"
export * from "./Positions.vue?vue&type=script&lang=js"
import style0 from "./Positions.vue?vue&type=style&index=0&id=7b9f7279&prod&lang=scss&scoped=true"
import style1 from "./Positions.vue?vue&type=style&index=1&id=7b9f7279&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f7279",
  null
  
)

export default component.exports